"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAsyncDebounce = useAsyncDebounce;

var _react = require("react");

function useAsyncDebounce(fn, delay) {
  var resolution = (0, _react.useRef)();
  return (0, _react.useCallback)(function () {
    // If there's no debounce running yet, configure one
    if (resolution.current == null) {
      var resolve;
      var promise = new Promise(function (internalResolve) {
        resolve = internalResolve;
      });
      resolution.current = {
        promise: promise,
        resolve: resolve
      };
    } // If there's an ongoing timeout, can it.


    if (resolution.current.timeoutHandle != null) {
      window.clearTimeout(resolution.current.timeoutHandle);
    }

    resolution.current.timeoutHandle = window.setTimeout(function () {
      // Grab & clear the resolution immediately to prevent races in
      // long-running user functions
      var currentResolution = resolution.current;
      resolution.current = undefined; // Run the user function, then unblock the resolution on completion

      fn().then(function () {
        return currentResolution === null || currentResolution === void 0 ? void 0 : currentResolution.resolve();
      });
    }, delay);
    return resolution.current.promise;
  }, [fn, delay]);
}